import { OnOffSwitchService } from "../Common/OnOffSwitchConfigurations/OnOffSwitchService";
import { IRomConfigService } from "./IRomConfigService";

export class RomConfigService extends OnOffSwitchService implements IRomConfigService{

    public static readonly ServiceName: string = "RomConfigService";

    constructor() {
        super();
    }

    GetServiceName(): string {
        return RomConfigService.ServiceName;
    }
}